import React, { useState, useEffect, useEffectEvent } from "react";
import { Table, Button, Spinner, Card, Form, Row, Col, } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import { Modal } from "react-bootstrap";



const Inventory = () => {
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddForm, setShowAddForm] = useState(false);

  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [showNewCategory, setShowNewCategory] = useState(false);
  const [newCategory, setNewCategory] = useState("");
  const [selectedTax, setSelectedTax] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [error, setError] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");

  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filterCategory, setFilterCategory] = useState("");
  const [filterBrand, setFilterBrand] = useState("");
  const [allProducts, setAllProducts] = useState([]);


  const [formData, setFormData] = useState({
    name: "",
    brand: "",
    price: "",
    mrp: "",
    sell_price: "",
    stock: "",
    barcode: "",
    tax: "",
    discount: "",
    discount_value: "",
    description: "",
    img: [],
  });


  const categoryOptions = [
    ...categories.map(cat => ({ label: cat, value: cat })),
    { label: "➕ Add new category", value: "__add_new__" }
  ];



  const taxOptions = [
    { label: "None", value: "" },
    { label: "0 %", value: "0 %" },
    { label: "0.25 %", value: "0.25 %" },
    { label: "3 %", value: "3 %" },
    { label: "5 %", value: "5 %" },
    { label: "12 %", value: "12 %" },
    { label: "18 %", value: "18 %" },
    { label: "28 %", value: "28 %" }
  ];

  const discountOptions = [
    { value: "amount", label: " Amount" },
    { value: "percent", label: "Percentage" },

  ];

  // Fetch products and categories
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get("https://api.bigfresh.in/fecth-product");
        const productList = Array.isArray(res.data)
          ? res.data
          : res.data?.productData || [];
        setProducts(productList);

        setFilteredProducts(productList);

        setAllProducts(productList);

        const uniqueCategories = [
          ...new Set(
            productList
              .map(product => product.category)
              .filter(Boolean)
          )
        ];

        setCategories(uniqueCategories);


      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch products", { position: "top-center" });
      } finally {
        setLoading(false);
      }
    };

  

    fetchProducts();
    fetchCategories();
  }, []);


//   useEffect(() => {

//   if (searchTerm.trim() === "" || filterBrand == "Select Brands") {

//     setFilteredProducts(allProducts);

//   }
//    else {

//     const filtered = allProducts.filter((product) =>
//       Object.values(product).some((value) =>
//         String(value || "")
//           .toLowerCase()
//           .includes(searchTerm.toLowerCase())
//       )
//     );

//     setFilteredProducts(filtered);
//   }

// }, [searchTerm, allProducts]);


useEffect(() => {

  // If everything is cleared → show all products
  if (
    searchTerm.trim() === "" &&
    filterBrand === "" &&
    filterCategory === ""
  ) {
    setFilteredProducts(allProducts);
    return;
  }

  const filtered = allProducts.filter((product) => {

    // SEARCH FILTER
    const matchesSearch =
      searchTerm.trim() === "" ||
      Object.values(product).some((value) =>
        String(value || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      );

    // BRAND FILTER
    const matchesBrand =
      filterBrand === "" ||
      String(product.brand || "").toLowerCase() ===
        filterBrand.toLowerCase();

    // CATEGORY FILTER
    const matchesCategory =
      filterCategory === "" ||
      String(product.category || "").toLowerCase() ===
        filterCategory.toLowerCase();

    return (
      matchesSearch &&
      matchesBrand &&
      matchesCategory
    );
  });

  setFilteredProducts(filtered);

}, [
  searchTerm,
  filterBrand,
  filterCategory,
  allProducts
]);

  const fetchCategories = async () => {
    try {
      const res = await axios.get(
        "https://api.bigfresh.in/categories"
      );


      setCategories(res.data || []);

    } catch (error) {
      console.error("Category error:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);


  const fetchItem = async (filters = {}) => {
    try {
      setLoading(true);

      const params = {};

      if (filters.brand) {
        params.brand = filters.brand;
      }

      if (filters.category) {
        params.category = filters.category;
      }

      if (filters.searchQuery) {
        params.searchQuery = filters.searchQuery;
      }

      const res = await axios.get(
        "https://api.bigfresh.in/get-admin-product",
        {
          params
        }
      );

      setProducts(res.data);


      if (filters.brand || filters.category || filters.searchQuery) {
        setFilteredProducts(res.data);
      } else {
        setFilteredProducts([]);
      }

    } catch (error) {
      console.error("Failed to fetch products", error);
      setError("Error fetching products!");
    } finally {
      setLoading(false);
    }
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, type, files, value } = e.target;

    if (type === "file") {
      const fileArray = Array.from(files);
      setFormData((prev) => ({
        ...prev,
        img: [...prev.img, ...fileArray],
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // Submit new product
  const handleAddProduct = async (e) => {
    e.preventDefault();


    const fd = new FormData();

    Object.keys(formData).forEach((key) => {
      if (key !== "img") fd.append(key, formData[key]);
    });

    formData.img.forEach((file) => fd.append("img", file));


    try {
      const res = await axios.post(
        "https://api.bigfresh.in/product-detail",
        fd
      );
      toast.success(res.data.message || "Product added successfully!", { position: "top-center" });
      setShowAddForm(false);

      // Refresh product list
      const updated = await axios.get("https://api.bigfresh.in/fecth-product");
      setProducts(Array.isArray(updated.data) ? updated.data : []);

      // Reset form
      setFormData({
        name: "",
        brand: "",
        price: "",
        mrp: "",
        sell_price: "",
        stock: "",
        barcode: "",
        tax: "",
        discount: "",
        discount_value: "",
        description: "",
        img: [],
      });
      setSelectedTax([]);
      setSelectedCategory("");
    } catch (error) {
      console.error(error);
      toast.error("Failed to add product", { position: "top-center" });
    }
  };



  // Delete product
  const handleDelete = async (id) => {


    try {
      await axios.delete(`https://api.bigfresh.in/delete-product/${id}`);
      setProducts((prev) => prev.filter((p) => p.id !== id));
      toast.success("Product deleted successfully!", { position: "top-center" });
    } catch (error) {
      console.error(error);
      toast.error("Delete failed", { position: "top-center" });
    }
  };


  const filteredData = products.filter(itm =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );


  const uniqueBrands = [
    ...new Set(
      allProducts
        .map((item) => item.brand)
        .filter(Boolean)
    )
  ];


  const uniqueCategories = categories;



  return (
    <div className="container-fluid p-4">

      <div className="mb-3">

        <h4 className="fw-bold text-success mb-3">Inventory</h4>

        <div className="d-flex justify-content-between align-items-center">

          <div className="w-50">
            <input
              type="text"
              className="form-control border-0 border-bottom border-dark"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>


          <Button
            variant={showAddForm ? "danger" : "success"}
            onClick={() => setShowAddForm((prev) => !prev)}
          >
            {showAddForm ? "Cancel" : "Add Product"}
          </Button>
        </div>
      </div>

      <div className="row g-2 justify-content-start mb-3">

        {/* BRAND */}
        <div className="col-12 col-sm-6 col-md-3">
          <select
            className="form-select form-select-sm"
            value={filterBrand}
            onChange={(e) => (
              setFilterCategory(''),
              setFilterBrand(e.target.value)
            )
            }
          >
            <option value="">Select Brands</option>

            {uniqueBrands.map((brand, index) => (
              <option key={index} value={brand}>
                {brand}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-sm-6 col-md-3">
          <select
            className="form-select form-select-sm"
            value={filterCategory}
            onChange={(e) => (
              setFilterCategory(e.target.value),
              setFilterBrand('')
            )
            }
          >
            <option value="">Select Categories</option>

            {uniqueCategories.map((category, index) => (
              <option key={index} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>


        {/* APPLY FILTER */}
        <div className="col-12 col-sm-auto">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={() => {
              fetchItem({
                brand: filterBrand,
                category: filterCategory,
                searchQuery: searchTerm
              });
            }}
          >
            Apply Filter
          </button>
        </div>

      </div>

      {/* Add Product Form */}
      {showAddForm && (
        <Card className="mb-4 shadow-sm">
          <Card.Header className="bg-success text-white">
            <h5 className="mb-0"> Add New Product</h5>
          </Card.Header>
          <Card.Body>
            <Form onSubmit={handleAddProduct}>
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Product Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Brand</Form.Label>
                    <Form.Control
                      type="text"
                      name="brand"
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Price</Form.Label>
                    <Form.Control
                      type="number"
                      name="price"
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>


                  <Form.Group className="mb-3">
                    <Form.Label>MRP</Form.Label>
                    <Form.Control
                      type="number"
                      name="mrp"
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Sell Price</Form.Label>
                    <Form.Control
                      type="number"
                      name="sell_price"
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>



                  <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="description"
                      onChange={handleChange}
                      rows={4}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Stock</Form.Label>
                    <Form.Control
                      type="number"
                      name="stock"
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Barcode</Form.Label>
                    <Form.Control
                      type="text"
                      name="barcode"
                      onChange={handleChange}
                    />
                  </Form.Group>



                  <Form.Group className="mb-3">
                    <Form.Label>Category</Form.Label>
                    <CreatableSelect
                      options={categoryOptions}
                      // value={categoryOptions.find(opt => opt.value === formData.category)}
                      value={
                        categoryOptions.find(
                          opt => opt.value === formData.category
                        ) || null
                      }


                      onChange={(option) => {
                        if (option.value === "__add_new__") {
                          setNewCategory("");
                          setShowNewCategory(true);
                          return;
                        }
                        setFormData(prev => ({ ...prev, category: option.value }));
                      }}
                      formatCreateLabel={(inputValue) => `➕ Add "${inputValue}"`}
                      onCreateOption={(inputValue) => {
                        setNewCategory(inputValue);
                        setShowNewCategory(true);
                      }}
                      required
                    />
                  </Form.Group>



                  {showNewCategory && (
                    <div
                      className="position-fixed top-50 start-50 translate-middle p-4 bg-white border rounded shadow"
                      style={{ width: "350px", zIndex: 1050 }}
                    >


                      <Form.Group className="mb-3">
                        <Form.Label>New Category </Form.Label>
                        <Form.Control
                          type="text"
                          value={newCategory}
                          onChange={(e) => setNewCategory(e.target.value)}
                          autoFocus
                        />
                      </Form.Group>

                      <div className="d-flex justify-content-end gap-2">
                        <Button
                          variant="secondary"
                          onClick={() => {
                            setShowNewCategory(false);
                            setNewCategory("");
                          }}
                        >
                          Cancel
                        </Button>

                        <Button
                          variant="success"
                          onClick={() => {
                            if (!newCategory.trim()) return;

                            if (!categories.includes(newCategory)) {
                              setCategories(prev => [...prev, newCategory]);
                            }

                            // store only value
                            setFormData(prev => ({ ...prev, category: newCategory }));

                            setNewCategory("");
                            setShowNewCategory(false);
                          }}
                        >
                          Save
                        </Button>

                      </div>
                    </div>
                  )}



                  <Form.Group className="mb-3">
                    <Form.Label>Tax</Form.Label>
                    <Select
                      classNamePrefix="react-select"
                      placeholder="Select tax"
                      options={taxOptions}
                      value={selectedTax}
                      onChange={(option) => {
                        setSelectedTax(option);
                        setFormData(prev => ({
                          ...prev,
                          tax: option?.value || ""
                        }));
                      }}
                    />

                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Discount</Form.Label>

                    <Select
                      placeholder="Select Discount"
                      options={discountOptions}
                      value={discountOptions.find(opt => opt.value === formData.discount)}
                      onChange={(option) =>
                        setFormData(prev => ({ ...prev, discount: option.value }))
                      }
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Discount Value</Form.Label>
                    <Form.Control
                      type="number"
                      name="discount_value"
                      onChange={handleChange}

                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Upload Images</Form.Label>
                    <Form.Control
                      type="file"
                      name="img"
                      multiple
                      accept="image/*"
                      onChange={handleChange}
                    />
                  </Form.Group>


                </Col>
              </Row>



              <div className="row">
                <div className="col-auto">
                  <button type="submit" className="btn btn-success">
                    Save
                  </button>
                </div>
              </div>


            </Form>
          </Card.Body>
        </Card>
      )}

      {/* Products Table */}
      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" />
        </div>
      ) : (
        <Table bordered hover responsive className="text-center align-middle">
          <thead className="table-dark">
            <tr>
              <th>SN</th>
              <th>Product Name</th>
              <th>Brand</th>
              <th>Purchase Price</th>
              <th>MRP</th>
              <th>Sell Price</th>
              <th>Barcode</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {filteredProducts.length === 0 ? (
              <tr>
                <td colSpan="8" className="text-muted text-center">
                  No products found
                </td>
              </tr>
            ) : (
              filteredProducts.map((prod, i) => (
                <tr key={prod.id}>
                  <td>{i + 1}</td>
                  <td>{prod.product_name}</td>
                  <td>{prod.brand}</td>
                  <td>₹{prod.price}</td>
                  <td>₹{prod.mrp}</td>
                  <td>₹{prod.sell_price}</td>
                  <td>{prod.barcode}</td>
                  <td>
                    <div className="d-flex flex-column flex-md-row gap-2 justify-content-center">
                      <Button
                        variant="info"
                        className="w-100 w-md-auto"
                        onClick={() => navigate(`/edit-product/${prod.id}`)}
                      >
                        Edit
                      </Button>
                      <Button
                        variant="danger"
                        className="w-100 w-md-auto"
                        onClick={() => setDeleteId(prod.id)}
                        data-bs-toggle="modal"
                        data-bs-target="#confirmDeleteModal"
                      >
                        Delete
                      </Button>


                    </div>
                  </td>

                </tr>
              ))
            )}
          </tbody>
        </Table>
      )}

      <ToastContainer />
      {/* Delete Confirmation Modal */}
      <div
        className="modal fade"
        id="confirmDeleteModal"
        tabIndex="-1"
        aria-labelledby="confirmDeleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title  text-danger" id="confirmDeleteModalLabel" >
                Confirm Delete
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              Are you sure you want to delete this product?
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => handleDelete(deleteId)}
                data-bs-dismiss="modal"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default Inventory;











